export default {"src":"/_next/static/media/processing.3e001434.gif","height":160,"width":160,"blurWidth":0,"blurHeight":0};